var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"centered":"","title":_vm.title,"hide-footer":""},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[(_vm.src)?_c('b-img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.src,"rounded":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }